import React, { Component, ReactNode } from "react";
import classnames from "classnames";

import { Page } from "@formant/ui/component/common/Page";

import { Section } from "../common/Section";
import { Container } from "../Container";
import * as styles from "./SettingsPage.scss";

export interface ISettingsPageProps {
    className?: string;
    narrow?: boolean;
    scrollable?: boolean;
    title: string;
    extra?: ReactNode;
    actions?: ReactNode;
    children?: React.ReactNode;
}

export class SettingsPage extends Component<ISettingsPageProps> {
    public render() {
        const {
            className,
            narrow,
            scrollable,
            title,
            extra,
            actions,
            children,
        } = this.props;
        return (
            <Page
                scrollable={scrollable}
                className={classnames(styles["settings-page"], className)}
            >
                <Container
                    narrow={narrow}
                    className={classnames(
                        styles.container,
                        scrollable && styles.scrollable,
                    )}
                >
                    <Section
                        className={styles.section}
                        title={title}
                        extra={extra}
                        actions={actions}
                    >
                        {children}
                    </Section>
                </Container>
            </Page>
        );
    }
}
